 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TITLE_PAGE from '@/components/title_page'
 import LOVE_1 from '@/components/love_1'
 import CHAP139527 from '@/components/chap139527'
 import CHAP139513 from '@/components/chap139513'
 import CHAP139510 from '@/components/chap139510'
 import CHAP139509 from '@/components/chap139509'
 import CHAP139515 from '@/components/chap139515'
 import CHAP139514 from '@/components/chap139514'
 import CHAP139528 from '@/components/chap139528'
 import CHAP139529 from '@/components/chap139529'
 import CHAP139531 from '@/components/chap139531'
 import CHAP139524 from '@/components/chap139524'
 import CHAP139504 from '@/components/chap139504'
 import CHAP139525 from '@/components/chap139525'
 import CHAP139532 from '@/components/chap139532'
 import CHAP139516 from '@/components/chap139516'
 import CHAP139523 from '@/components/chap139523'
 import CHAP139512 from '@/components/chap139512'
 import CHAP139506 from '@/components/chap139506'
 import CHAP139505 from '@/components/chap139505'
 import CHAP139526 from '@/components/chap139526'
 import CHAP139507 from '@/components/chap139507'
 import CHAP139519 from '@/components/chap139519'
 import CHAP139520 from '@/components/chap139520'
 import CHAP139533 from '@/components/chap139533'
 import CHAP139517 from '@/components/chap139517'
 import CHAP139521 from '@/components/chap139521'
 import CHAP139508 from '@/components/chap139508'
 import CHAP139522 from '@/components/chap139522'
 import CHAP139511 from '@/components/chap139511'
 import CHAP139530 from '@/components/chap139530'
 import LOVE_2 from '@/components/love_2'
 import CHAP139518 from '@/components/chap139518'
 import CHAP153557 from '@/components/chap153557'
 import CHAP139536 from '@/components/chap139536'
 import CREDITS from '@/components/credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/title_page",
 			"name" : "title_page",
 			"component" : TITLE_PAGE
 		},
 		{
 			"path" : "/love_1",
 			"name" : "love_1",
 			"component" : LOVE_1
 		},
 		{
 			"path" : "/chap139527",
 			"name" : "chap139527",
 			"component" : CHAP139527
 		},
 		{
 			"path" : "/chap139513",
 			"name" : "chap139513",
 			"component" : CHAP139513
 		},
 		{
 			"path" : "/chap139510",
 			"name" : "chap139510",
 			"component" : CHAP139510
 		},
 		{
 			"path" : "/chap139509",
 			"name" : "chap139509",
 			"component" : CHAP139509
 		},
 		{
 			"path" : "/chap139515",
 			"name" : "chap139515",
 			"component" : CHAP139515
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js